import { useMaskito } from "@maskito/react";
import * as React from "react";
import { Input } from "@volca/ui/components/ui/input";
import { Label } from "@volca/ui/components/ui/label";
import { Stack } from "@volca/ui/components/ui/stack";
import { createTypeableDateMask } from "@volca/ui/components/ui/typeable-date-picker";
import { FORMAT_TYPEABLE_DATE_PLACEHOLDER } from "@volca/ui/lib/date";
import { RANGE_END, type RangeEnd } from "./utils";

interface TypedRangeFieldsProps {
  idPrefix: string;
  textFor: (end: RangeEnd) => string;
  onTypedChange: (end: RangeEnd, text: string) => void;
  onBlur: () => void;
}

export const TypedRangeFields = ({
  idPrefix,
  textFor,
  onTypedChange,
  onBlur,
}: TypedRangeFieldsProps) => {
  const fromOptions = React.useMemo(() => createTypeableDateMask(), []);
  const toOptions = React.useMemo(() => createTypeableDateMask(), []);
  const fromMask = useMaskito({ options: fromOptions });
  const toMask = useMaskito({ options: toOptions });

  return (
    <Stack
      direction="row"
      align="center"
      gap={2}
      className="mb-3 border-b pb-3"
    >
      {[RANGE_END.from, RANGE_END.to].map((end) => (
        <Stack key={end} direction="row" align="center" gap={2}>
          <Label htmlFor={`${idPrefix}-${end}`}>
            {end === RANGE_END.from ? "From" : "To"}
          </Label>
          <Input
            id={`${idPrefix}-${end}`}
            ref={end === RANGE_END.from ? fromMask : toMask}
            type="text"
            inputMode="numeric"
            autoFocus={end === RANGE_END.from}
            className="w-32"
            placeholder={FORMAT_TYPEABLE_DATE_PLACEHOLDER}
            value={textFor(end)}
            onInput={(e) => onTypedChange(end, e.currentTarget.value)}
            onBlur={onBlur}
          />
        </Stack>
      ))}
    </Stack>
  );
};
